import {autoserializeAs, inheritSerialization} from 'cerialize';
import {ModelBase} from './model-base';

@inheritSerialization(ModelBase)
export class EnclosureCard extends ModelBase {
  public static readonly type = 'EnclosureCard';
  public readonly type = EnclosureCard.type;

  @autoserializeAs('id')
  public id: number;

  @autoserializeAs('group_id')
  public groupId: string;

  @autoserializeAs('text')
  public text: string;
}
